import React, { Component, useEffect, useState } from "react";
import ComponentTransactionHistoryMobile from "./ComponentTransactionHistoryMobile";
import ComponentTransactionHistoryWeb from "./ComponentTransactionHistoryWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentTransactionHistory = () => {
  const gaEventTracker = useAnalyticsEventTracker("Transaction");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Transaction",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentTransactionHistoryWeb></ComponentTransactionHistoryWeb>
      </BrowserView>
      <MobileView>
        <ComponentTransactionHistoryMobile></ComponentTransactionHistoryMobile>
      </MobileView>
    </>
  );
};

export default ComponentTransactionHistory;
